// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
let __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_emotion_react_jsx-runtime_dist_emotion-react-jsx-runtime_browser_develop-d7b906"], () => (__webpack_require__("./src/index.tsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
